import React, { useState, useEffect } from "react";

export const Fade = ({ children, visible, duration = 400, ...props }) => {
  const [isVisible, setVisible] = useState(visible);

  useEffect(() => {
    if (visible) {
      setVisible(true);
    }
  }, [visible]);

  const onAnimationEnd = () => {
    if (!visible) {
      setVisible(false);
    }
  };

  if (isVisible) {
    return (
      <div
        {...props}
        style={{ animation: `${visible ? "fadeIn" : "fadeOut"} ${duration}ms` }}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    );
  }

  return null;
};
